<template>
  <div class="page-container">
    <section class="mt-4 mb-10">
      <h1 v-if="me" class="font-size--24">
        휴일 없이 어제의 매장/배달 매출을 오늘 오전에 정산 받으세요.
      </h1>
      <v-footer fixed>
        <v-layout :class="{ 'px-3': !$vuetify.breakpoint.mobile }">
          <BasicButton class="button next-button" depressed height="48" @click="earlypayCheck">
            신청하기
          </BasicButton>
        </v-layout>
      </v-footer>
    </section>
    <section>
      <ul class="font-size--14 color--nice-grey outer">
        <li>365 오전 선정산은 P2P 방식으로 온라인 모집하여 지급합니다.</li>
      </ul>
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { defaultApi } from '@/plugins/api/defaultApi'
import { redirectSignupManage } from '@/util/signupManage'
export default {
  computed: {
    ...mapState('contract', {
      contractCurrent: 'current',
    }),
    ...mapState('auth', ['me']),
    isEarlyPaymentEnabled() {
      console.log('********* isEarlyPaymentEnabled', this.contractCurrent)
      return (
        this.contractCurrent?.status === 'started' &&
        this.contractCurrent.isEarlyPaymentEnabled === true
      )
    },
  },
  async created() {
    _meta({
      titles: ['선정산 설명'],
    })
    if (await redirectSignupManage()) {
      return
    }

    if( this.isEarlyPaymentEnabled ) {
      await this.$router.push('/earlypay')
    }

  },
  watch: {
    me: {
      deep: true,
      immediate: true,
      async handler() {
        
      },
    },
  },
  methods: {
    ...mapActions('auth', ['getMe']),
    ...mapActions('loansRequest', {
      storeAddRequest: 'addRequest',
      storeGetRequests: 'getRequests',
    }),
    async earlypayCheck() {
      await this.$router.push('/earlypay-check')
    },
  },
}
</script>
<style lang="scss" scoped>
#section__success {
  .v-card {
    background-color: #f4faff;
  }
}
</style>
